







import Vue from "vue";

export default Vue.extend({
  components: {},
  data() {
    return {
      error: ""
    };
  },
  mounted() {
    try {
      const query = this.$route.query;
      const oidcToken = query["oidc_token"];
      const redirectUrl = query["redirect"];
      const pamHostName = new URL(redirectUrl).host;
      const email = query["email"];
      const lang = query["language"];
      if (redirectUrl) {
        sessionStorage.setItem(`OIDC-TOKEN-${pamHostName}`, oidcToken);
        window.location.href = redirectUrl + `?lang=${lang}&email=${email}`;
      }
    } catch (e) {
      this.error = e;
    }

  }
});
